import React from "react";
import Select from "react-select";
import { Button } from "aible";

import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown, faEye, faPlus } from "@fortawesome/free-solid-svg-icons";

import FeatureChartContainer from "containers/FeatureChart/FeatureChart";
import PartialDepPlotContainer from "containers/RunPlot/PartialDepPlot";

import BullseyeBlue from "images/bullseye-arrow-light-blue.svg";
import AcademicBlue from "images/academic-blu.svg";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { STEP_TYPE, WIZARD_SECTIONS, ORIGINAL_STEPS } from "containers/Wizard/reducer";
import { PROJECT_MODES } from "containers/Run/reducer";

import styles from "./style.module.css";

export default class WizardModel extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { miniHover: false };
  }

  renderCreate() {
    const { onClick, isFull, aibleMode, project } = this.props;

    return (
      <div className={styles.miniHeaderNoHover}>
        <div className={styles.modelInfo}>
          <div className={styles.modelStuff} style={{ marginLeft: "10px" }}>
            <Button onClick={() => onClick()}>
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: "5px" }} />
              {"New prediction"}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  renderFull() {
    const { isFull, aibleMode, handleDeleteProject, project } = this.props;

    return (
      <div className={styles.modelInfo}>
        {project && project.id !== undefined && (
          <div className={styles.delHolder}>
            <Button
              style={{ padding: "2px" }}
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteProject(project.id);
              }}
            >
              {"Delete"}
            </Button>
          </div>
        )}
        <div className={styles.imgContainer + " " + (isFull ? styles.imgContainerLarge : "")}>
          <img src={aibleMode == "academic" ? AcademicBlue : BullseyeBlue} />
        </div>
        {project && (
          <div className={styles.modelStuff}>
            <div className={styles.boldLine}>{project.name}</div>
            <div className={styles.line} style={isFull ? { display: "flex" } : {}}>
              <span className={styles.leftLine}>{"Subgroups:"}</span>
              {project.segment_count}
            </div>
            <div className={styles.line} style={isFull ? { display: "flex" } : {}}>
              <span className={styles.leftLine}>{"Contributors:"}</span>
              {project.roles.length}
            </div>
            <div className={styles.line} style={isFull ? { display: "flex" } : {}}>
              <span className={styles.leftLine}>{"Created:"}</span>
              {moment.utc(project.created_date).local().fromNow()}
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { isFull, isCreate, aibleMode, outcome, dataset, datasetLabel, model, created, onClick, search, onChange } =
      this.props;
    const { miniHover } = this.state;

    if (isCreate) {
      return this.renderCreate();
    }

    if (isFull) {
      return (
        <div className={styles.miniHeaderFull} onClick={() => onClick()}>
          {this.renderFull()}
        </div>
      );
    }

    return (
      <div className={styles.miniHeader}>
        <Button type="secondary" className={styles.change} onClick={() => onChange()}>
          {"Change"}
        </Button>
        <div className={styles.fHolder}>
          <div className={styles.changeHolder}>{this.renderFull()}</div>
        </div>
      </div>
    );
  }
}
